export enum ObjectType {
  ExternalUser = 'external-user',
  Task = 'task',
  User = 'user'
}

export const nameMap = {
  [ObjectType.ExternalUser]: 'Contacts',
  [ObjectType.Task]: 'Tasks',
  [ObjectType.User]: 'Users'
}
